/** Contact & brand — aligned with live qbcon.in */
export const SITE = {
  name: 'Quick Build Con',
  legalName: 'Quick Build Con',
  /** Brand mark — served from qbc-web/public */
  logo: '/logoqbc.webp',
  /** 480px copy of the 6000px master for on-page <img> (schema / og keep `logo`). */
  logoSmall: '/logoqbc-header.webp',
  logoAspect: 6000 / 1230,
  phone: '+91 99041 56561',
  phoneTel: '+919904156561',
  whatsapp: '919904156561',
  email: 'quickbuildcon@gmail.com',
  emailAlt: 'quickbuildcon@gmail.com',
  address: 'A-505, Nana Mava Rd, Karan Park, Rajkot, Gujarat 360001',
  nap: {
    street: 'A-505, Nana Mava Rd, Karan Park',
    locality: 'Rajkot',
    region: 'Gujarat',
    postalCode: '360001',
    country: 'IN',
    hoursLabel: 'Mon–Sat 10:00 AM – 7:00 PM',
    latitude: 22.278309,
    longitude: 70.778177,
  },
  hours: [
    { days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], opens: '10:00', closes: '19:00' },
  ],
  footerBg: '#063b66',
  social: {
    facebook: 'https://www.facebook.com/share/1Dd7MCjd9Y/',
    instagram: 'https://www.instagram.com/qbc_properties/',
    youtube: 'https://www.youtube.com/@quickbuildcon3888',
    linkedin: 'https://www.linkedin.com/company/quick-build-con-qbc',
  },
  apps: {
    playStore: 'https://play.google.com/store/apps/details?id=com.qbc',
    appStore: 'https://apps.apple.com/in/app/quick-build-con/id1583958782',
    playStoreBadge: 'https://admin.qbcon.in/website/img/home/footer/google-play-store.png',
    appStoreBadge: 'https://admin.qbcon.in/website/img/home/footer/apple-store.png',
  },
} as const

export const CITIES = [
  { id: 1, name: 'Ahmedabad', slug: 'ahmedabad' },
  { id: 2, name: 'Rajkot', slug: 'rajkot' },
  { id: 3, name: 'Surat', slug: 'surat' },
  { id: 4, name: 'Gandhinagar', slug: 'gandhinagar' },
  { id: 5, name: 'Vadodara', slug: 'vadodara' },
  { id: 6, name: 'Jamnagar', slug: 'jamnagar' },
  { id: 7, name: 'Bhavnagar', slug: 'bhavnagar' },
] as const

export const HERO_TABS = [
  { id: 'buy', label: 'Buy', intent: 'buy' },
  { id: 'rent', label: 'Rent', intent: 'rent' },
  { id: 'projects', label: 'New Projects', intent: 'buy', category: 'New Project' },
  { id: 'commercial', label: 'Commercial', intent: 'commercial' },
  { id: 'plots', label: 'Plots/Land', intent: 'buy', category: 'plots' },
] as const

export type HeroTab = (typeof HERO_TABS)[number]

/** Whether the active hero tab requests premium listings. */
export function heroTabPremium(tab: HeroTab): boolean | undefined {
  if (!('premium' in tab)) return undefined
  return Boolean((tab as { premium?: unknown }).premium) || undefined
}

export function heroTabCategory(tab: HeroTab): 'New Project' | 'plots' | undefined {
  if (!('category' in tab)) return undefined
  return tab.category
}

/** API / suggestion scope derived from the active hero search tab. */
export function heroTabScope(tab: HeroTab) {
  return {
    intent: tab.intent,
    ...(heroTabPremium(tab) ? { premium: true as const } : {}),
    ...(heroTabCategory(tab) ? { category: heroTabCategory(tab) } : {}),
  }
}
